export enum AdobeAnalyticsAction {
  ASSIGNMENT_CREATED = 'assignmentCreated',
  ASSIGNMENT_STARTED = 'assignmentStarted',
  ASSESSMENT_STARTED = 'assessmentStarted',
  ASSIGNMENT_COMPLETED = 'assignmentCompleted',
  ASSESSMENT_COMPLETED = 'assessmentCompleted',
  CONTENT_VIEW = 'contentView',
  NAVIGATION_CLICK = 'navigationClick',
  NEW_PAGE = 'newPage',
  PRODUCT_FEATURE_USED = 'productFeatureUsed',
  SURVEY_SUBMISSION = 'SurveySubmission',
  GEN_AI_CONTENT_UPDATED = 'genAIContentUpdated',
  BUTTON_CLICK = 'buttonClick',
}

export enum AdobeAnalyticsButtonType {
  ANCHOR = 'anchor',
  FORM_CONTROL = 'form-control',
  MENU = 'menu',
  TAB_SWITCH = 'tab-switch',
  BUTTON = 'button',
}

export enum AdobeAccessTypes {
  ANON_GUEST = 'ANON_GUEST',
  ANON_IP = 'ANON_IP',
  REG_GUEST = 'REG_GUEST',
  REG_USER = 'REG_USER'
}

export enum AdobeLoginStatus {
  LOGGED_IN = 'logged in',
  ANONYMOUS = 'anonymous'
}

export type AdobeAnalyticsVisitor = {
  accessType: string;
  loginStatus: string;
  loginSuccess: string;
  loginFailure: string;
  accountId: string;
  accountName: string;
  ipAddress: string;
  userId: string;
  departmentId: string;
  departmentName: string;
  usagePathInfo: string;
  details: unknown;
  accountNumber: string; // institution id
}
export type AdobeAnalyticsPage = {
  businessUnit: string;
  environment: string;
  productName: string;
  language: string;
  name: string;
  type: string;
  testId: string;
  channel: string;
  loadTime: number;
  loadTimestamp: string;
  analyticsPagename: string;
  sectionName: string;
  lastTrackedPage: string;
  cmsName: string;
  noTracking: string;
  eventName: string;
}
export type AdobeAnalyticsEducation = {
  courseId: string;
  courseName: string;
  isbn: string;
  assignmentId: string;
  assignmentName: string;
  assignmentType: string;
  moduleId: string;
  moduleName: string;
  moduleType: string;
  studentId: string;
  instructorId: string;
  semester: string;
  beforeAfterDueDate: string; // date compared to assignment due date in the format "due date +||- Int"
  assignmentNumericGrade: string;
  assignmentDuration: string;
  assignmentScore: string;
}
export type AdobeAnalyticsContent = Partial<{ // for books
  entitlementType: string;
  format: string;
  id: string;
  type: string;
  details: string;
  position: string;
  publicationType: string;
  isbn: string;
  provider: string;
}>

export type AdobeAnalyticsPageData = {
  visitor: Partial<AdobeAnalyticsVisitor>;
  page: Partial<AdobeAnalyticsPage>;
  education: Partial<AdobeAnalyticsEducation>;
  content: AdobeAnalyticsContent[];
  survey: unknown;
  buttonType: string;
}

export enum AdobeAnalyticsProductFeature {
  ACTIVITY_MODAL_LIST_VIEW_BTN_TOGGLE_CLICK = 'activity_modal_list_view_btn_toggle_click',
}

export type AdobeAnalyticsActionProps = {
  action: AdobeAnalyticsAction;
  pageData: Partial<AdobeAnalyticsPageData>;
}
